import { baseUrl } from '../../network'  

export const getProvidersFilters = (companyId: number) => baseUrl + `api/company/${companyId}/providers/filters`
export const getProvidersUrl = (companyId: number) => baseUrl + `api/company/${companyId}/providers` 
export const createProvidersUrl = (companyId: number) => baseUrl + `api/company/${companyId}/providers`
export const deleteProviderUrl = (relationship: number) => baseUrl + `api/provider/${relationship}`